<template>

    <div class="admin-page">
        <Header></Header>
        <section class="admin-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-4">
                        <h1>Stages List</h1>
                    </div>
                    <div class="col-md-4 text-center">
                        <router-link class="next-icon add-btn" style="float: none;" :to="`/admin/artist/`+artistId"><img src="@/assets/img/prev.svg"/> Artist</router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link class="next-icon add-btn" :to="`/admin/artist/`+artistId+`/stage/create`">Add Stage <img src="@/assets/img/next.svg"/></router-link>
                    </div>
                </div>
                <div class="row">
                   <table class="table table-striped">
                       <thead>
                            <tr>
                                <th>Name</th>
                                <th style="width: 250px;">Action</th>
                            </tr>
                       </thead>
                       <tbody>
                            <tr v-for="(list) in lists" v-bind:key="list.id">
                                <td>{{list.title}}</td>
                                <td><router-link class="edit" :to="`/admin/artist/` + artistId + `/stage/` + list._id">Edit</router-link> <a href="javascript:void(0)" :data-id="list._id" data-toggle="modal" data-target="#deleteModal" v-on:click="deleteFunction" class="delete">Delete</a> </td>
                            </tr>
                       </tbody>
                   </table>
                </div>
            </div>
        </section>
        <Footer :dataId="deleteRecord" :dataModel="model"></Footer>
    </div>
</template>


<script>
    import Header from '../Header'
    import Footer from '../Footer'
    import axios from 'axios'
    import router from '../../../router'
    export default {
        name: 'StagesList',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        mounted () {
            axios
                .get('/getartistdetail', {
                    params: {
                        artistId: this.artistId
                    }
                })
                .then(response => {
                    this.lists = response.data.stages
                })
                .catch(error => console.log(error))
        },
        data() {
            return {
                artistId: router.history.current.params.id,
                msg: 'Welcome to Your Vue.js App',
                deleteRecord: '',
                model: 'Stage',
                lists: ''
            }
        },
        methods: {
            deleteFunction(e) {
                this.deleteRecord = e.target.dataset.id
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/stages/List.vue